import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() =>
  createStyles({
    iconButton: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      height: "54px",
      width: "54px",
      background: "#475467",
      opacity: 0.6,
      borderRadius: "50%",
      cursor: "pointer",

      "&:hover": {
        opacity: 1,
        background: "#475467",
        transition: "opacity 0.2s ease-in-out",
      },

      "&:disabled": {
        opacity: 0.6,
        background: "#475467",
      },

      "& svg": {
        height: "22px",
        width: "22px",
        color: "#FFF",
      },
    },

    tooltip: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",

      "& svg": {
        height: "9px",
        width: "9px",
        color: "#FFF",
      },

      "& span": {
        fontFamily: "Manrope",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "12px",
        lineHeight: "24px",
        color: "#FFF",
      },
    },
  })
);

export default styles;
